import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import { transfer } from '../../../../actions/api';
import DataTable from "../../../DataTable";
import Form, { FormActions } from "../../../Form";
import Spinner from "../../../Spinner";
import { getDisplayDate } from "../../../../libs/date";

@inject("transferStore", "parameterStore", "stationStore")
@observer
class TableList extends React.Component {
    componentDidMount() {
        const { parameterStore, transferStore, stationStore } = this.props;
        if (!parameterStore.isLoading && parameterStore.items.length === 0) parameterStore.fetchItems();
        if (!transferStore.isLoading && transferStore.items.length === 0) transferStore.fetchItems();
        if (!stationStore.isLoading && stationStore.items.length === 0) stationStore.fetchItems();
    }

    static contextTypes = {
        router: PropTypes.object.isRequired,
        notify: PropTypes.object.isRequired,
    }

    @observable selectedTab = "Ongoing";

    onSelectTransfer = (item) => {
        const { router } = this.context;
        router.replace(`/tools/data_movement/${item.id}/details`);
    }

    render() {
        const { transferStore, children, parameterStore } = this.props;

        if (transferStore.isLoading) { return <Spinner />; }
        let data = transferStore.items.filter((item) => this.selectedTab === "Completed" ? item.status === 2 : item.status !== 2).sort((a, b) => a.id - b.id)
            .map((item, index) => {
                const { created_at, date_from, date_reached, date_to, status, parameter_id, ...others } = item;
                const correspondingParameter = parameterStore.findById(parameter_id);
                return {
                    ...others,
                    created_at: getDisplayDate(created_at),
                    date_from: getDisplayDate(date_from),
                    date_to: getDisplayDate(date_to),
                    date_reached: date_reached ? getDisplayDate(date_reached) : '-',
                    date_reached_raw: date_reached,
                    status: status === 2 ? 'Completed' : status === 1 ? 'Ongoing' : 'Stopped',
                    parameter_code: correspondingParameter ? correspondingParameter.code : '',
                    sn: index + 1,
                    filter_duplicate: item.filter_duplicate ? 'Yes' : 'No',
                    delete_from_source: item.delete_from_source ? 'Yes' : 'No',
                }
            });

        return <div>
            <div className="TabBar TabBarRounded">
                <ul>
                    <li className={this.selectedTab === "Ongoing" ? "active" : ""} onClick={() => this.selectedTab = "Ongoing"}>
                        <a>Ongoing/Stopped</a>
                    </li>
                    <li className={this.selectedTab === "Completed" ? "active" : ""} onClick={() => this.selectedTab = "Completed"}>
                        <a> Completed</a>
                    </li>
                </ul>
            </div>

            <DataTable
                data={data}
                slug={'tools/data_movement'}
                columns={[
                    { key: 'sn', label: 'SN' },
                    { key: 'id', label: 'ID' },
                    { key: 'remark', label: 'Remark' },
                    { key: 'created_at', label: 'Initiated Date' },
                    { key: 'date_from', label: 'Date From' },
                    { key: 'date_to', label: 'Date To' },
                    { key: 'date_reached', label: 'Date Reached' },
                    { key: 'source_table.name', label: 'Source Table' },
                    { key: 'destination_table.name', label: 'Destination Table' },
                    { key: 'filter_duplicate', label: 'Filter Duplicate' },
                    { key: 'delete_from_source', label: 'Delete From Source' },
                    { key: 'status', label: 'Status' },
                ]}
                allowAdd
                renderButtons={(row) => {
                    return <Form key={row.id} className="action">
                        {row.status !== "Completed" &&
                            <button onClick={(e) => {
                                e.preventDefault();
                                if (row.status === 'Ongoing') {
                                    transfer.transferStop(row.id).then(() => {
                                        transferStore.updateStatus(row.id, 0);
                                    });
                                } else if (row.status === 'Stopped') {
                                    transfer.transferStart(row.id).then(() => {
                                        transferStore.updateStatus(row.id, 1);
                                    });
                                }
                            }}>{row.status === 'Ongoing' ? 'Stop' : "Start"}</button>
                        }
                    </Form>
                }}
                resource='transfer'
                onSelect={this.onSelectTransfer}
            />
            <Form>
                <FormActions>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button onClick={(e) => {
                            e.preventDefault();
                            this.props.transferStore.fetchItems();
                        }}>Refresh</button>
                    </div>
                </FormActions>
            </Form>
            {children}
        </div>
    }
}

export default TableList;



// WEBPACK FOOTER //
// ./src/components/Tools/DataMovement/BetweenTables/TableList.js